export const routerLabels = {
  contactFormPage: "/contact-form-page"
}
